import axiosInstance from "../../utils/axiosCompany";

export const CreateAddOnCategory = async (values) => {
    return await axiosInstance().post("company/menu-add-on/create-category", values);
}

export const GetAddOnCategoryList = async (values) => {
    return await axiosInstance().post("company/menu-add-on/list-categories", values);
}

export const GetAllParentAddOnCategories = async (values) => {
    return await axiosInstance().post("company/menu-category/get-all-parent-categories", values);
}


export const GetSingleAddOnCategory = async (values) => {
    return await axiosInstance().post("company/menu-add-on/get-single-category", values);
}

export const GetAllAddOnCategory = async (values) => {
    return await axiosInstance().post("company/menu-add-on/get-all-categories", values);
}

export const editAddOnCategory = async (values) => {
    return await axiosInstance().post("company/menu-add-on/update-category", values)
}

export const ChangeAddOnCategoryStatus = async (values) => {
    return await axiosInstance().post("company/menu-add-on/change-category-status", values)
}

export const DeleteAddOnCategory = async (values) => {
    return await axiosInstance().post("company/menu-add-on/delete-category", values);
}

export const reorderAddonCategories = async (values) => {
    return await axiosInstance().post("company/menu-add-on/reorder-categories", values);
}


// addOns Api
export const CreateAddOn = async (values) => {
    return await axiosInstance().post("company/menu-add-on/create-add-on", values);
}

export const ListAddOn = async (values) => {
    return await axiosInstance().post("company/menu-add-on/list-add-ons", values);
}
export const ChangeStatusAddOn = async (values) => {
    return await axiosInstance().post("company/menu-add-on/change-add-on-status", values);
}
export const DeleteAddOn = async (values) => {
    return await axiosInstance().post("company/menu-add-on/delete-add-on", values);
}
export const EditAddOn = async (values) => {
    return await axiosInstance().post("company/menu-add-on/update-add-on", values);
}
export const SingleAddOn = async (values) => {
    return await axiosInstance().post("company/menu-add-on/get-single-add-on", values);
}

// Every add-on the list's filters match, with categories and outlet prices,
// for the Bulk Actions export.
export const ExportAllAddOns = async (values) => {
    return await axiosInstance().post("company/menu-add-on/export-all-add-ons", values);
}

// Add-ons parsed from a spreadsheet on the list page. Posts { brand_id, add_ons }
// where add_ons is a JSON array of { name, category_skus, default_price,
// short_description, pricing_type } — the data, not the file.
export const ImportAddOns = async (values) => {
    return await axiosInstance().post("company/menu-add-on/import-addons", values);
}

// Existing add-on recipes for the brand, filtered like the add-on list, used to
// fill the recipes template. Returns { recipe_list, order_modes }.
export const ExportAddOnRecipes = async (values) => {
    return await axiosInstance().post("company/menu-add-on/export-recipes", values);
}

// Add-on recipes parsed from the exported sheet on the list page. Posts
// { brand_id, recipes } where recipes is a JSON array of
// { add_on_id, recipe_sku, quantity, order_mode_short_codes } — the data, not the file.
export const ImportAddOnRecipes = async (values) => {
    return await axiosInstance().post("company/menu-add-on/import-recipes", values);
}

// Base and default prices of the add-ons the list's filters match, for the
// Pricing export.
export const ExportAddOnsPricing = async (values) => {
    return await axiosInstance().post("company/menu-add-on/export-add-ons-pricing", values);
}

// Add-on prices parsed from the pricing sheet on the list page. Posts
// { brand_id, prices, default_prices, specific_prices }, each a JSON array:
// prices of { id, price }; default_prices and specific_prices of
// { id, aggregator_id, order_mode_id, price }, specific_prices rows also with
// outlet_short_codes [] — the data, not the file.
export const ImportAddOnsPricing = async (values) => {
    return await axiosInstance().post("company/menu-add-on/import-add-ons-pricing", values);
}
